import { render } from "./StatusBadge.vue?vue&type=template&id=eda955b4"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"
script.render = render

export default script